export default __webpack_public_path__ + "c83675d091dc9f23b47b997103ffb7b4.png";